import { Controller } from "@hotwired/stimulus"

// Choosing an image in the item form suggests that image's category — only into
// an empty select, so a category the coordinator picked is never overwritten.
export default class extends Controller {
  static targets = ["select"]

  suggest({ params: { category } }) {
    if (!category || !this.hasSelectTarget || this.selectTarget.value) return

    // The TomSelect draws its own control: setting .value alone leaves it showing the old choice.
    const tomSelect = this.selectTarget.tomselect
    if (tomSelect) tomSelect.setValue(category)
    else this.selectTarget.value = category
  }
}
